import { useQuery } from '@tanstack/react-query';
import { getUserInfo } from '@/utils';
import { UserApiService } from '@/api/userProfile/UserApiService';
import { UserProfileDto } from '@/models';
import { AxiosError } from 'axios';
import { userProfileCacheKeys } from '@/api/queries/userProfile/cacheKeys';
import { useAuthContext } from '@/context/AuthContext';

const getUserProfile = async (id: string): Promise<UserProfileDto> => {
  const response = await UserApiService.getUser(id);
  return response.data.body;
};

export const useFetchUserProfile = () => {
  const { token } = useAuthContext();

  return useQuery<UserProfileDto, AxiosError>({
    queryKey: userProfileCacheKeys.fetch,
    queryFn: () => getUserProfile(getUserInfo(token).sub),
    enabled: !!token,
  });
};
